
import { Component, Vue } from 'vue-property-decorator';
import LayoutDefault from '@/components/layout/default/LayoutDefault.vue';

@Component({
  components: {
    LayoutDefault
  }
})
export default class DashboardDefault extends Vue {
  // Remove all the component logic and keep only basic structure
  // The notifications and profile functionality should be handled by LayoutDefault
}
